import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import {LayoutContext} from './table';
import {TableRowWrapper} from './TableRowWrapper';
import {LoadMorePlaceholder} from './LoadMorePlaceholder';

export const TableRows = ({
	children,
	data,
	level,
	canExpand,
	initiallyExpanded,
	hasHeader,
	loadMore,
	autoload,
	loading,
	disableVirtualization,
	keyFunc,
	onExpansion,
}) => {
	const tableLayout = useContext(LayoutContext);
	const nextLevel = level < 5 ? level + 1 : false;
	const expandEnabled = index => canExpand && (index > 0 || !hasHeader);

	const rows = [];

	if (data.rows) {
		rows.push(
			data.rows.map((dataRow, index, array) => (
				<TableRowWrapper
					isLastRow={index === array.length - 1 && !loadMore}
					isHeader={hasHeader && index === 0}
					key={`row-${keyFunc ? keyFunc(dataRow) : index}`}
					hasGroupings={tableLayout.hasGroupings}
					rowData={dataRow}
					level={level}
					nextLevel={nextLevel}
					render={children}
					index={index}
					canExpand={expandEnabled(index)}
					initiallyExpanded={initiallyExpanded}
					disableVirtualization={disableVirtualization}
					onExpansion={onExpansion}
				/>
			))
		);
	}

	if (loadMore) {
		rows.push(
			<VisibilitySensor key="load-more-wrapper-visibility-sensor" partialVisibility>
				{({isVisible}) => (
					<LoadMorePlaceholder
						columns={tableLayout.columns}
						hasGroupings={tableLayout.hasGroupings}
						loading={loading}
						isVisible={isVisible}
						level={level}
						loadMore={loadMore}
						autoload={autoload}
					/>
				)}
			</VisibilitySensor>
		);
	}
	return rows;
};

TableRows.propTypes = {
	level: PropTypes.oneOf([1, 2, 3, 4, 5]),
	data: PropTypes.shape({
		totals: PropTypes.object,
		rows: PropTypes.array.isRequired,
	}).isRequired,
	/**
	 * Render prop. Passes in data row as input
	 */
	children: PropTypes.func.isRequired,
	canExpand: PropTypes.bool.isRequired,
	initiallyExpanded: PropTypes.bool.isRequired,
	hasHeader: PropTypes.bool,
	loadMore: PropTypes.func,
	keyFunc: PropTypes.func,
	loading: PropTypes.bool,
	disableVirtualization: PropTypes.bool,
	onExpansion: PropTypes.func,
};

TableRows.defaultProps = {
	level: 1,
	canExpand: false,
	initiallyExpanded: false,
};
